import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { PAGELENGTH } from 'components/common/ListLayout';
import Api from "services/api"


export const initialState = {
    interpreterAppointments: [],
    interpreterAssignedJobs: [],
    interpreterAvailableJobs: [],
    interpreterCompletedJobs: [],
    error: null,
    loader: false,
    featured: {},
    total: 0,
    is_more: false,
    last_page: 1,
    current_page: 1,
    per_page: PAGELENGTH,
    popup: {
        show: false,
        item: {}
    },
}

export const interpreterAppointmentsSlice = createSlice({
    name: 'interpreterAppointments',
    initialState: initialState,
    reducers: {
        setAppointment: (state, { payload }) => {
            state.interpreterAppointments = payload?.data ?? payload;
            state.total = payload?.total;
            state.is_more = payload?.is_more;
            state.last_page = payload?.last_page;
            state.current_page = payload?.current_page;
            state.per_page = payload?.per_page;
        },
        setInterpreterAppointments: (state, { payload }) => {
            state.interpreterAppointments = payload?.data;
            state.total = payload?.total;
            state.is_more = payload?.is_more;
            state.last_page = payload?.last_page;
            state.current_page = payload?.current_page;
            state.per_page = payload?.per_page;
        },
        setInterpreterAssignedJobs: (state, { payload }) => {
            state.interpreterAssignedJobs = payload?.data;
            state.total = payload?.total;
            state.is_more = payload?.is_more;
            state.last_page = payload?.last_page;
            state.current_page = payload?.current_page;
            state.per_page = payload?.per_page;
        },
        setInterpreterAvailableJobs: (state, { payload }) => {
            state.interpreterAvailableJobs = payload?.data;
            state.total = payload?.total;
            state.is_more = payload?.is_more;
            state.last_page = payload?.last_page;
            state.current_page = payload?.current_page;
            state.per_page = payload?.per_page;
        },
        setInterpreterCompletedJobs: (state, { payload }) => {
            state.interpreterCompletedJobs = payload?.data;
            state.total = payload?.total;
            state.is_more = payload?.is_more;
            state.last_page = payload?.last_page;
            state.current_page = payload?.current_page;
            state.per_page = payload?.per_page;
        },
        setMoreInterpreterAppointments: (state, { payload }) => {
            state.data = state.data.concat(payload.data);
            state.total = payload.total;
            state.is_more = payload.is_more;
            state.last_page = payload?.last_page;
            state.current_page = payload?.current_page;
            state.per_page = payload?.per_page;
        },
        removeAppointment: (state, { payload }) => {
            state.error = payload
        },
        clearAllAppointment: (state, { payload }) => {
            state.loader = payload
        },
        setError: (state, { payload }) => {
            state.error = payload
        },
        setLoader: (state, { payload }) => {
            state.loader = payload
        },
        setAddAppointmentPopup: (state, { payload }) => {
            state.popup = payload
        },
        closeAppointmentPopup: (state) => {
            state.popup.show = false;
            state.popup.item = {}
        }
    }
})

export const fetchInterpreterAppointments = (page, params, disableLoader) => async (dispatch) => {
    const apiService = new Api();
    !disableLoader && dispatch(setLoader(true))
    try {
  
      const result = await Api.fetchInterpreterAppointments(page, params)
      if (result.status >= 200 && result.status < 300) {
        if (page > 1) {
          dispatch(setInterpreterAppointments(result.data.data));
        } else {
          dispatch(setInterpreterAppointments(result.data.data));
        }
      }
      else if (result?.status == 422) {
        dispatch(setError(result.data))
      }
    } catch (error) {
      console.log("error", error)
  
    }
    !disableLoader && dispatch(setLoader(false))
  }


  export const fetchInterpreterAssignedJobs = (page, params, disableLoader) => async (dispatch) => {
    const apiService = new Api();
    !disableLoader && dispatch(setLoader(true))
    try {
  
      const result = await Api.fetchInterpreterAssignedJobs(page, params)
      if (result.status >= 200 && result.status < 300) {
        if (page > 1) {
          dispatch(setInterpreterAssignedJobs(result.data.data));
        } else {
          dispatch(setInterpreterAssignedJobs(result.data.data));
        }
      }
      else if (result?.status == 422) {
        dispatch(setError(result.data))
      }
    } catch (error) {
      console.log("error", error)
  
    }
    !disableLoader && dispatch(setLoader(false))
  }
  export const fetchInterpreterAvailableJobs = (page, params, disableLoader) => async (dispatch) => {
    const apiService = new Api();
    !disableLoader && dispatch(setLoader(true))
    try {

      const result = await Api.fetchInterpreterAvailableJobs(page, params)
      if (result.status >= 200 && result.status < 300) {
        if (page > 1) {
          dispatch(setInterpreterAvailableJobs(result.data.data));
        } else {
          dispatch(setInterpreterAvailableJobs(result.data.data));
        }
      }
      else if (result?.status == 422) {
        dispatch(setError(result.data))
      }
    } catch (error) {
      console.log("error", error)
  
    }
    !disableLoader && dispatch(setLoader(false))
  }
  export const fetchInterpreterCompletedJobs = (page, params, disableLoader) => async (dispatch) => {
    const apiService = new Api();
    !disableLoader && dispatch(setLoader(true))
    try {

      const result = await Api.fetchInterpreterCompletedJobs(page, params)
      if (result.status >= 200 && result.status < 300) {
        if (page > 1) {
          dispatch(setInterpreterCompletedJobs(result.data.data));
        } else {
          dispatch(setInterpreterCompletedJobs(result.data.data));
        }
      }
      else if (result?.status == 422) {
        dispatch(setError(result.data))
      }
    } catch (error) {
      console.log("error", error)
  
    }
    !disableLoader && dispatch(setLoader(false))
  }


export const fetchInterpreterAppointmentView = (id, callback) => async (dispatch) => {
    const apiService = new Api();
    dispatch(setError({}))
    dispatch(setLoader(true))
    try {
        const result = await Api.fetchInterpreterAppointmentView(id)
        if (result.status >= 200 && result.status < 300) {
            callback && callback(true, result?.data?.message, result?.data?.data)
        } else if (result?.status == 422) {
            callback && callback(false, result?.data?.message)
        }
    } catch (error) {
        // callback&&callback(false)
        callback && callback(false, error?.data?.message)
    }
    dispatch(setLoader(false))
}

export const fetchInterpreterAppointmentLogs = (id, callback) => async (dispatch) => {
    const apiService = new Api();
    dispatch(setError({}))
    dispatch(setLoader(true))
    try {
        const result = await Api.fetchInterpreterAppointmentLogs(id)
        if (result.status >= 200 && result.status < 300) {
            callback(true, result?.data?.message, result?.data?.data)
        } else if (result?.status == 422) {
            callback(false, result?.data?.message)
        }
    } catch (error) {
        // callback(false)
        callback(false, error?.data?.message)
    }
    dispatch(setLoader(false))
}

export const interpreterCheckinCheckout = (id, data, callback) => async (dispatch) => {
  const apiService = new Api();
  dispatch(setError({}))
  dispatch(setLoader(true))
  try {
    const json = await Api.interpreterCheckinCheckout(data, id)
    if (json.status >= 200 && json.status < 300) {
      console.log(json)
      callback(true, json.data.message)
    } else if (json.status == 422) {
      dispatch(setError(json.data))
      callback(false, json.data.message)
    }
  } catch (error) {
    console.log(error)

  }
  dispatch(setLoader(false))
}

export const answerAppointmentInvite = (id, data, callback) => async (dispatch) => {
  const apiService = new Api();
  dispatch(setError({}))
  dispatch(setLoader(true))
  try {
    const json = await Api.answerAppointmentInvite(id, data)
    if (json.status >= 200 && json.status < 300) {
      console.log(json)
      callback(true, json.data.message)
    } else if (json.status == 422) {
      dispatch(setError(json.data))
      callback(false, json.data.message)
    }
  } catch (error) {
    console.log(error)

  }
  dispatch(setLoader(false))
}


export const cancelJob = (id, callback) => async (dispatch) => {
  const apiService = new Api();
  dispatch(setError({}))
  dispatch(setLoader(true))
  try {
    const json = await Api.cancelJob(id)
    if (json.status >= 200 && json.status < 300) {
      console.log(json)
      callback(true, json.data.message)
    } else if (json.status == 422) {
      dispatch(setError(json.data))
      callback(false, json.data.message)
    }
  } catch (error) {
    console.log(error)

  }
  dispatch(setLoader(false))
}

export const { 
    setAppointment, setInterpreterAppointments, setInterpreterAssignedJobs, setInterpreterAvailableJobs, setInterpreterCompletedJobs,
    clearAllAppointment, setLoader,
    setError, setMoreInterpreterAppointments,
    setAddAppointmentPopup, closeAppointmentPopup

} = interpreterAppointmentsSlice.actions


export default interpreterAppointmentsSlice.reducer
export const interpreterAppointmentsSelector = state => state.interpreterAppointments


